/* DSPopupMedia — состояние загрузки картинки в попапах.

   Попапы темы либо переиспользуют один <img> под разные товары (tea-sheet),
   либо держат картинку в скрытом диалоге с loading="lazy" — браузер начинает
   грузить её только при открытии. И в том, и в другом случае в первый момент
   видно не то, что нужно: чужое фото или пустой бокс.

   Модуль ведёт один атрибут data-media-loading на боксе [data-popup-media];
   всё видимое (гашение кадра, spinner, белая подложка) — в ds-components.css. */

(function () {
  'use strict';

  function media(el) {
    if (!el) return null;
    if (el.hasAttribute && el.hasAttribute('data-popup-media')) return el;
    return el.querySelector ? el.querySelector('[data-popup-media]') : null;
  }

  function settle(box) {
    if (box) box.setAttribute('data-media-loading', 'false');
  }

  /* Ждём именно эту картинку: у переиспользуемого бокса до load может прилететь
     ещё один swap, и старый обработчик снял бы spinner с нового кадра. */
  function track(el) {
    var box = media(el);
    if (!box) return;

    var img = box.querySelector('img');
    if (!img) {
      settle(box);
      return;
    }

    /* Попап уже открыт — картинка нужна сейчас. Без снятия lazy браузер решает
       сам и в скрытом до этого диалоге может тянуть с запросом. */
    if (img.loading === 'lazy') img.loading = 'eager';

    if (img.complete && img.naturalWidth > 0) {
      settle(box);
      return;
    }

    box.setAttribute('data-media-loading', 'true');

    var token = (parseInt(box.dataset.mediaToken, 10) || 0) + 1;
    box.dataset.mediaToken = token;

    var fallback = null;
    var done = function () {
      img.removeEventListener('load', done);
      img.removeEventListener('error', done);
      if (fallback) clearTimeout(fallback);
      if (String(box.dataset.mediaToken) === String(token)) settle(box);
    };

    img.addEventListener('load', done);
    img.addEventListener('error', done);

    /* Страховка: если load почему-то не придёт (медленная сеть, отменённый
       запрос), кадр не должен остаться погашенным навсегда. */
    fallback = setTimeout(done, 8000);
  }

  /* Гасим кадр до того, как попап поедет вверх: пустой бокс со spinner'ом
     честнее, чем фото предыдущего товара. */
  function clear(el) {
    var box = media(el);
    if (!box) return;

    box.setAttribute('data-media-loading', 'true');
    box.dataset.mediaToken = (parseInt(box.dataset.mediaToken, 10) || 0) + 1;

    var img = box.querySelector('img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('src');
  }

  /* attrs: { src, srcset, sizes, alt }. Пустой src оставляет бокс погашенным —
     дальше показывать нечего, и это забота вызывающего кода. */
  function swap(el, attrs) {
    var box = media(el);
    if (!box) return;

    clear(box);

    var img = box.querySelector('img');
    if (!img || !attrs || !attrs.src) return;

    if (typeof attrs.alt === 'string') img.alt = attrs.alt;
    /* srcset до src, иначе браузер успевает начать грузить мелкий вариант */
    if (attrs.srcset) {
      img.srcset = attrs.srcset;
      if (attrs.sizes) img.sizes = attrs.sizes;
    }
    img.src = attrs.src;

    track(box);
  }

  window.DSPopupMedia = { track: track, clear: clear, swap: swap };
})();
